import REAR_BIN_MAPPING from './rear-bin-mapping';

let init = () => {
  console.log('Board not connected');
};
// let wrapperObj = null;
let ipcRendererObj = null;
let openBin = binId => {
  console.log(`openBin called with ${binId}`);
  console.log('Board not connected');
};

let closeApplication = () => {
  console.log('Not running in electronjs');
};

if (window.electron) {
  let { /* app, */ ipcRenderer, remote } = window.electron;
  // if (app) wrapperObj = app;
  if (ipcRenderer) ipcRendererObj = ipcRenderer;

  closeApplication = () => {
    remote.getCurrentWindow().close();
  };

  openBin = binId => {
    //Added By Kishan for Rear Screen Bin Mapping
    const rearStock =
      localStorage.getItem('rearStock') &&
      (localStorage.getItem('rearStock') === 'true' ||
        localStorage.getItem('rearStock') === -true)
        ? true
        : false;

    if (rearStock) {
      console.log('Before:', binId);
      binId = REAR_BIN_MAPPING[binId];
      console.log('openBin-RearStock:', binId);
    } else {
      console.log('openBin-Front:', binId);
    }
    const command = JSON.stringify({
      command: 'open-bin',
      binId
    });
    if (ipcRendererObj) {
      ipcRendererObj.send('kiosk-to-main', command);
    }
    console.log(command);
  };

  init = () => {
    if (ipcRendererObj) {
      ipcRendererObj.on('main-to-kiosk', (event, arg) => {
        console.log('main-to-kiosk');
        console.log(event);
        console.log(arg);
        console.log('message received by kiosk');
      });
      console.log('Board initialized');
    } else {
      console.log('Board not initialized');
      console.log(ipcRendererObj);
    }
  };
}

export { init, /* wrapperObj, */ ipcRendererObj, openBin, closeApplication };
